"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H3"));

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _QuestionEntityRecord = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/QuestionEntityRecord"));

var _PropertyQuestionAndAnswerContent = _interopRequireDefault(require("./PropertyQuestionAndAnswerContent"));

var _FreeformQuickAnswerContent = _interopRequireDefault(require("./FreeformQuickAnswerContent"));

var _NoteContent = _interopRequireDefault(require("./NoteContent"));

var BaseQuestionBlock = function BaseQuestionBlock(_ref) {
  var alertMessage = _ref.alertMessage,
      alertType = _ref.alertType,
      question = _ref.question,
      disabled = _ref.disabled,
      objectProperty = _ref.objectProperty,
      objectPropertyError = _ref.objectPropertyError,
      onSubmissionChanged = _ref.onSubmissionChanged,
      onPropertyChanged = _ref.onPropertyChanged,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      relatedObject = _ref.relatedObject;
  return _react.default.createElement("div", {
    className: "question-and-answer-content",
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    "data-selenium-test": "q-and-a-block"
  }, _react.default.createElement(_UITile.default, {
    className: "p-all-5"
  }, _react.default.createElement(_H.default, {
    className: "m-top-0 m-bottom-3 p-all-0"
  }, question.question), _react.default.createElement(_PropertyQuestionAndAnswerContent.default, {
    question: question,
    relatedObject: relatedObject,
    objectProperty: objectProperty,
    disabled: disabled || !!objectPropertyError,
    tooltip: objectPropertyError,
    onSubmissionChanged: onSubmissionChanged,
    onPropertyChanged: onPropertyChanged
  }), _react.default.createElement(_FreeformQuickAnswerContent.default, {
    question: question,
    disabled: disabled,
    onSubmissionChanged: onSubmissionChanged
  }), _react.default.createElement(_NoteContent.default, {
    question: question,
    onSubmissionChanged: onSubmissionChanged,
    disabled: disabled
  }), alertMessage && _react.default.createElement(_UIAlert.default, {
    type: alertType,
    className: "m-top-4",
    use: "inline"
  }, alertMessage)));
};

BaseQuestionBlock.propTypes = {
  alertMessage: _propTypes.default.node,
  alertType: _propTypes.default.oneOf(['danger', 'success', 'warning', 'info', 'tip']),
  question: _propTypes.default.instanceOf(_QuestionEntityRecord.default).isRequired,
  disabled: _propTypes.default.bool,
  objectProperty: _propTypes.default.object,
  objectPropertyError: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),
  onSubmissionChanged: _propTypes.default.func,
  relatedObject: _propTypes.default.object,
  onPropertyChanged: _propTypes.default.func,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func
};
BaseQuestionBlock.defaultProps = {
  disabled: false
};
var _default = BaseQuestionBlock;
exports.default = _default;
module.exports = exports.default;